import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { GlobalProvider } from "../global";

/*
  Generated class for the NewEzoomApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NewEzoomApiProvider {
    // private apiUrl: string = "https://www.recreiodajuventude.com.br/api/";
    private apiUrl: string = "http://localhost/recreio/api/";
    private apiToken: string = "EZRJ7392";
    private apiVersion: string = "2.6";

    constructor(
        public ohttp: Http,
        private http: HttpClient,
        private global: GlobalProvider
    ) {
        console.log("Hello NewEzoomApiProvider Provider");
    }

    /*
    Metódo de conexão Get
    Retorna resultado da requisição feita à url base, vinda de src/environments
    */
    async get(method: string, params?: HttpParams): Promise<any> {
        const head = await this.getHeaders();
        return new Promise((resolve, reject) => {
            this.http
                .get(this.apiUrl + method, { headers: head, params })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    async post(method: string, params): Promise<any> {
        console.log(params);
        const headers = await this.getHeaders();
        return new Promise((resolve, reject) => {
            this.http
                .post(this.apiUrl + method, params, { headers })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    /*
    Criação de cabeçalhos
    */
    private async getHeaders() {
        let sessionId;
        await this.global.getSessionId().then((res) => {
            if (res) {
                sessionId = res;
            }
        });
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "api-token": this.apiToken,
            "api-version": this.apiVersion,
            Accept: "application/json",
            "session-id": sessionId,
        };
        return headers;
    }

    async getSessionId() {}
}



// WEBPACK FOOTER //
// ./src/providers/new-ezoom-api/new-ezoom-api.ts